module.exports = "/images/vendor/desiigner-svg/svg/logos/italia-on-the-road-live.svg?b257f3ecb1c5ce5d930b7685443d7097";